/**
 * DuzenlemeTalebiBildirimi — the staff Kişi Detay's one-line notice: "this kişi has N Edit Kişi Requests waiting" with a link to the approval list
 * filtered to the kişi (backlog #749; backend #747). Silent when there are none, when the caller may not read them (page.kisi) or when the read fails.
 * The decision itself (Onayla / Reddet) is on KisiDuzenlemeTalepleriPage, not here.
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { getDuzenlemeTalepleri, TALEP_DURUMU } from '../../services/kisiDuzenlemeTalebiService';

export default function DuzenlemeTalebiBildirimi({ personId, reloadToken = 0 }) {
  const { t } = useTranslation('yonetim');
  const [sayi, setSayi] = useState(0);

  useEffect(() => {
    let ignore = false;
    getDuzenlemeTalepleri({ durum: TALEP_DURUMU.BEKLIYOR, personId, size: 1 })
      .then((d) => { if (!ignore) setSayi(d?.bekleyenSayisi ?? 0); })
      .catch(() => { if (!ignore) setSayi(0); });
    return () => { ignore = true; };
  }, [personId, reloadToken]);

  if (!sayi) return null;
  return (
    <Alert fade={false} color="warning" className="py-2" data-testid="duzenleme-talebi-bildirimi">
      {t('kisiDuzenlemeTalepleri.bildirim', { count: sayi })}{' '}
      <Link to={`/Management/Kisi/DuzenlemeTalepleri?personId=${personId}`}>{t('kisiDuzenlemeTalepleri.bildirimBaglanti')}</Link>
    </Alert>
  );
}
